import { Typography } from "@material-ui/core";
import React from "react";

const InfoAutoFeatures = ({ features }) => {
  const groups = features.reduce((acc, feature) => {
    const key = feature.infoauto_feature.category;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(feature);
    return acc;
  }, {});

  if (features.length === 0) {
    return <></>;
  }
  return (
    <div className="info-auto-features">
      <Typography variant="h6 py-1">Características</Typography>
      <div className="row">
        {groups &&
          Object.keys(groups).map((key, index) => (
            <div key={index} className="col-4">
              <Typography variant="body1 mb-2">{key}</Typography>
              <div>
                {groups[key].map((feature, index) => (
                  <div
                    key={`feature-${index}`}
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <p key={index} className="mb-0" style={{ fontWeight: 400 }}>
                      {feature.infoauto_feature.name}
                    </p>
                    <p className="mb-0">
                      {feature.label
                        ? feature.label + "(" + feature.value + ")"
                        : feature.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default InfoAutoFeatures;
